<template>
  <v-container class="error-404 justify-center text-center py-12" fill-height>
    <div class>
      <p class="mb-6">
        <v-icon :size="120" color="secondary darken-2">mdi-emoticon-sad-outline</v-icon>
      </p>
      <h1 class="display-4 secondary--text darken-1 mb-2">404</h1>
      <h4 class="secondary--text darken-1 mb-10">عذراً، الرابط لم يعد صالح أو تم نقله.</h4>
      <p class>
        <router-link aria-label="الرئيسية" :to="{ name: 'Home' }">
          <v-btn aria-label="الرئيسية" class="rounded" color="primary" outlined>الرئيسية</v-btn>
        </router-link>
      </p>
    </div>
  </v-container>
</template>

<script>
// export
export default {
  // name
  name: 'Error404',
  // metaInfo
  metaInfo() {
    return {
      title: 'الرابط غير صالح'
    }
  }
}
</script>

<style>
.error-404 {
  min-height: 100%;
}
</style>
